// Инициализация лайтбокса для набора элементов details

import Lightbox from '../elements/Lightbox';
import getDetailsContent from './getDetailsContent';

/**
 * Инициализация лайтбокса для набора элементов details
 * 
 * Набор элементов является связанным для листания внутри лайтбокса.
 * 
 * @param detailsElements Набор элементов datails
 */
function main( detailsElements )
{
	const lightboxContent = [];
	const lightbox = Lightbox.instance;
	
	for ( let i = 0, n = detailsElements.length; i < n; i++ )
	{
		const details = detailsElements[i];
		const parent = details.parentElement;
		
		if ( !parent )
		{
			continue;
		}
		
		lightboxContent.push( getDetailsContent( details ) );
		
		parent.addEventListener(
			'click',
			( event ) =>
			{
				if ( event.target.classList.contains( 'close' ) )
				{
					return;
				}
				
				event.preventDefault();

				if ( parent.dataset.openId )
				{
					lightbox.open( lightboxContent[i], () => { window.history.replaceState( {}, document.title, location.pathname ); } );
					window.history.replaceState( {}, document.title, location.pathname + `?open=${parent.dataset.openId}` );
				}
				else
				{
					lightbox.open( lightboxContent[i] );
				}
			},
		);
	}
}

/**
 * Module
 */
export {
	main as default,
};



//////////////////
// WEBPACK FOOTER
// ./app/utils/initDetailsLightbox.js
// module id = A2VA
// module chunks = 1 4 7 8 9